import { createContext, useCallback, useState } from "react";

export const ErrorContext = createContext();

export function ErrorContextProvider({ children }) {
    const [error, setError] = useState(null);

    const removeError = () => setError(null);

    const addError = (message, status) => setError({ message, status });

    const contextValue = {error, addError: useCallback((message, status) => addError(message, status),[]),
        removeError: useCallback(() => removeError(), []),
    };

    return (
        <ErrorContext.Provider value={contextValue}>
            {children}
        </ErrorContext.Provider>
    );
}
